import React from 'react';
import { useReveal } from '../lib/useReveal';
const COST_DATA = [{
  sin: 'Años sintiendo que el cuerpo habla sin saber interpretarlo',
  costo: 'Tiempo que no vuelve'
}, {
  sin: 'Síntomas sin explicación emocional',
  costo: 'Frustración que se acumula'
}, {
  sin: 'Cursos sueltos que no conectan',
  costo: 'Dinero gastado sin estructura real'
}, {
  sin: 'Sin protocolo de sesión claro',
  costo: 'Inseguridad en el momento más importante'
}, {
  sin: 'Sin sistema de profesionalización',
  costo: 'Ingresos que no llegan'
}, {
  sin: 'El mismo ciclo de postergación',
  costo: 'El próximo año igual que este'
}];
export function CostSection() {
  const [ref, vis] = useReveal();
  return <section className="bg-black py-12 md:py-16 px-4 sm:px-6 border-t border-white/5" data-id="element-86">
      <div className="container mx-auto max-w-4xl" data-id="element-87">
        <div ref={ref} className={`reveal ${vis ? 'is-visible' : ''}`} data-id="element-88">
          <h2 className="text-2xl md:text-4xl font-serif font-bold mb-8 md:mb-12 text-center text-white tracking-wide" data-id="element-89">
            ⚖️ ¿CUÁNTO CUESTA NO TENERLO?
          </h2>

          <div className="overflow-x-auto pb-4 mb-10" data-id="element-90">
            <table className="w-full min-w-[600px] border-collapse bg-[#111111] rounded-xl overflow-hidden border border-white/10" data-id="element-91">
              <thead data-id="element-92">
                <tr data-id="element-93">
                  <th className="text-left p-5 border-b border-white/10 text-gray-400 font-medium w-1/2 bg-white/5" data-id="element-94">
                    Sin MegaPack
                  </th>
                  <th className="text-left p-5 border-b border-red-500/30 text-red-400 font-bold w-1/2 bg-red-500/5" data-id="element-95">
                    Costo real
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-96">
                {COST_DATA.map((row, i) => <tr key={i} className="border-b border-white/5 hover:bg-white/[0.02] transition-colors" data-id="element-97">
                    <td className="p-5 text-gray-300 text-sm md:text-base" data-id="element-98">
                      {row.sin}
                    </td>
                    <td className="p-5 text-red-300 font-medium text-sm md:text-base bg-red-500/[0.02]" data-id="element-99">
                      {row.costo}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>

          <div className="text-center space-y-4" data-id="element-100">
            <p className="text-xl md:text-2xl text-white font-medium" data-id="element-101">
              El próximo paso en tu camino puede empezar hoy.
            </p>
            <p className="text-2xl md:text-3xl font-serif font-bold text-[#eab308] italic" data-id="element-102">
              "El cuerpo habla. Aprendé a escucharlo." 🧬
            </p>
          </div>
        </div>
      </div>
    </section>;
}